import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { SiteLayout } from './components/layout/SiteLayout';
import { Spinner } from './components/ui';
import Home, { CustomPage } from './pages/public/Home';

// Public routes are split per page; the admin app is a separate lazy bundle.
const Details = {
  Business: lazy(() => import('./pages/public/Details').then((m) => ({ default: m.BusinessDetail }))),
  Place: lazy(() => import('./pages/public/Details').then((m) => ({ default: m.PlaceDetail }))),
  Temple: lazy(() => import('./pages/public/Details').then((m) => ({ default: m.TempleDetail }))),
  Village: lazy(() => import('./pages/public/Details').then((m) => ({ default: m.VillageDetail }))),
  Event: lazy(() => import('./pages/public/Details').then((m) => ({ default: m.EventDetail }))),
  Article: lazy(() => import('./pages/public/Details').then((m) => ({ default: m.ArticleDetail }))),
  History: lazy(() => import('./pages/public/Details').then((m) => ({ default: m.HistoryDetail }))),
  Gallery: lazy(() => import('./pages/public/Details').then((m) => ({ default: m.GalleryDetail }))),
  Job: lazy(() => import('./pages/public/Details').then((m) => ({ default: m.JobDetail }))),
};
const HistoryPage = lazy(() => import('./pages/public/History'));
const SearchPage = lazy(() => import('./pages/public/Search'));
const SavedPage = lazy(() => import('./pages/public/Saved'));
const Preview = lazy(() => import('./pages/public/Preview'));
const NotFound = lazy(() => import('./pages/public/NotFound'));
const SubmitBusiness = lazy(() => import('./pages/submit/SubmitBusiness'));
const SubmitJob = lazy(() => import('./pages/submit/SubmitJob'));
const Submit = {
  Hub: lazy(() => import('./pages/submit/SubmitOther').then((m) => ({ default: m.SubmitHub }))),
  Place: lazy(() => import('./pages/submit/SubmitOther').then((m) => ({ default: m.SubmitPlace }))),
  Event: lazy(() => import('./pages/submit/SubmitOther').then((m) => ({ default: m.SubmitEvent }))),
  History: lazy(() => import('./pages/submit/SubmitOther').then((m) => ({ default: m.SubmitHistory }))),
  Photos: lazy(() => import('./pages/submit/SubmitOther').then((m) => ({ default: m.SubmitPhotos }))),
  Track: lazy(() => import('./pages/submit/SubmitOther').then((m) => ({ default: m.TrackPage }))),
};
const AdminApp = lazy(() => import('./admin/AdminApp'));

const Loading = () => <div className="flex min-h-[50vh] items-center justify-center"><Spinner className="size-8" /></div>;

function Dir({ name }: { name: string }) {
  return <DirectoryRoute name={name} />;
}
const DirectoryRoute = lazy(async () => {
  const m = await import('./pages/public/Directory');
  return { default: ({ name }: { name: string }) => <m.default config={m.DIRECTORIES[name]} key={name} /> };
});

export default function App() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/preview" element={<Preview />} />
        <Route element={<SiteLayout />}>
          <Route index element={<Home />} />
          <Route path="businesses" element={<Dir name="businesses" />} />
          <Route path="businesses/:slug" element={<Details.Business />} />
          <Route path="places" element={<Dir name="places" />} />
          <Route path="places/:slug" element={<Details.Place />} />
          <Route path="temples" element={<Dir name="temples" />} />
          <Route path="temples/:slug" element={<Details.Temple />} />
          <Route path="villages" element={<Dir name="villages" />} />
          <Route path="villages/:slug" element={<Details.Village />} />
          <Route path="events" element={<Dir name="events" />} />
          <Route path="events/:slug" element={<Details.Event />} />
          <Route path="articles" element={<Dir name="articles" />} />
          <Route path="articles/:slug" element={<Details.Article />} />
          <Route path="history" element={<HistoryPage />} />
          <Route path="history/:slug" element={<Details.History />} />
          <Route path="gallery" element={<Dir name="gallery" />} />
          <Route path="gallery/:slug" element={<Details.Gallery />} />
          <Route path="jobs" element={<Dir name="jobs" />} />
          <Route path="jobs/:slug" element={<Details.Job />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="saved" element={<SavedPage />} />
          <Route path="submit" element={<Submit.Hub />} />
          <Route path="submit/business" element={<SubmitBusiness />} />
          <Route path="submit/place" element={<Submit.Place />} />
          <Route path="submit/event" element={<Submit.Event />} />
          <Route path="submit/job" element={<SubmitJob />} />
          <Route path="submit/history" element={<Submit.History />} />
          <Route path="submit/photos" element={<Submit.Photos />} />
          <Route path="track" element={<Submit.Track />} />
          <Route path=":slug" element={<CustomPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

